import React from 'react';
import Abbr from '../../shared/Abbr';
import { sortByRaceName } from '../../utils/name';

const handicapColumns = prefix => [
    {
        key: `${prefix}wins`,
        header: 'wins',
    },
    {
        key: `${prefix}runs`,
        header: 'runs',
    },
    {
        key: `${prefix}percentage`,
        header: '%',
    },
    {
        key: `${prefix}stake`,
        header: '£1 stake',
    },
];

const columns = [
    {
        key: 'raceName',
        header: () => <Abbr title="by favourites">fav</Abbr>,
        sortFn: sortByRaceName('raceName'),
    },
    ...handicapColumns('nh_'),
    ...handicapColumns(''),
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/course/favourites/columns.jsx